import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {SellableSearchModel} from "../sellable-search.model";
import {SellableEntityModel} from "../sellable-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {SearchActionEvent} from "../../../framework/entity/search/search-page/search-action-event";
import {EditParams} from "../../../framework/entity/edit/edit-page/edit-params";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {FUIStackedPageService} from "@fedeltapointofsale/ui";
import {ProductLineEditPageComponent} from "../../product-line/product-line-edit-page/product-line-edit-page.component";
import {
    CompositeProductEditPageComponent
} from "../../composite-product/composite-product-edit-page/composite-product-edit-page.component";
import {SellableData} from "../sellable.data";

@Component({
    selector: "wbo-sellable-search-page",
    templateUrl: "./sellable-search-page.component.html",
    providers: [
        provideSearchModel(SellableSearchModel),
        provideEntityModel(SellableEntityModel)
    ]
})
export class SellableSearchPageComponent extends AbstractSearchPage {

    constructor(public model: SellableSearchModel,
                private stackedPageService: FUIStackedPageService) {
        super();
    }

    openEntity(event: SearchActionEvent): void {
        if (event.item.sellableType === SellableData.SELLABLE_TYPE_PRODUCT_LINE) {
            this.stackedPageService.open(ProductLineEditPageComponent, new EditParams(this.searchPageComponent.searchModel.getIdentifier(event.item), EditMode.VIEW));
        } else if (event.item.sellableType === SellableData.SELLABLE_TYPE_COMPOSITE_PRODUCT) {
            this.stackedPageService.open(CompositeProductEditPageComponent, new EditParams(this.searchPageComponent.searchModel.getIdentifier(event.item), EditMode.VIEW));
        }
    }

    newProductLine(): void {
        this.searchPageComponent.newEntity(undefined, "product-line");
    }

    newCompositeProduct(): void {
        this.searchPageComponent.newEntity(undefined, "composite-product");
    }
}
